import { render } from "./project_list.vue?vue&type=template&id=7d8c87a7&scoped=true"
import script from "./project_list.js?vue&type=script&lang=js"
export * from "./project_list.js?vue&type=script&lang=js"

import "./project_list.vue?vue&type=style&index=0&id=7d8c87a7&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d8c87a7"]])

export default __exports__